import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CrudService {

  //*********** Testing *****************

  //  siteUrl: string = 'https://vmstest.ficci.in:8081/api/';
  //  DownLoadURl: string = 'https://vmstest.ficci.in:8081/';

   tdsApiUrl: string = 'https://teamapi.ficci.in/api/';
   tdsUrl: string = 'https://teamapi.ficci.in?u=YWRtaW4=';


  // siteUrl: string = 'http://192.168.12.155:9092/api/';
  //  DownLoadURl:string='http://192.168.12.155:9092/';


  // *********** Live *****************
   siteUrl: string = 'https://vms.ficci.in:8081/api/';
   DownLoadURl: string = 'https://vms.ficci.in:8081/';

  //  tdsApiUrl: string = 'http://localhost:9095/api/';
  //  tdsUrl: string = 'http://localhost:9095?u=YWRtaW4=';


  // *********** Local *****************

//  siteUrl: string = 'http://localhost:44390/api/';
//  DownLoadURl:string='http://localhost:44390/';


//set NODE_OPTIONS=--openssl-legacy-provider



  constructor(private http: HttpClient) { }
  get<T>(url): Observable<T> {
    return this.http.get<T>(this.siteUrl + url);
  }

  getWithHeaders(url, headers): any {
    return this.http.get(this.siteUrl + url, headers);
  }

  post<T>(url, body): any {

    return this.http.post<T>(this.siteUrl + url, body);
  }
  patch<T>(url, body): any {
    return this.http.patch<T>(this.siteUrl + url, body);
  }

  postWithHeader(url, body, headers): any {
    return this.http.post(this.siteUrl + url, body, headers);
  }

  put<T>(url, body): any {
    return this.http.put<T>(this.siteUrl + url, body);
  }



  getTDS<T>(url): Observable<T> {
    return this.http.get<T>(this.tdsApiUrl + url);
  }
}
